/* Reusable Function
*
* whenever you want to use date picker, this is the great example
* how to write the function code that are needed to control the
* value of date range picker
*
*  */
import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const useDateRangePicker = () => {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // function for date range picker
  const [selectedDate, setSelectedDate] = React.useState({
    start: (!searchParams.get('start')) ? new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString('en-US') : searchParams.get('start') ?? new Date(new Date().setDate(new Date().getDate() - 1)).toLocaleDateString('en-US'),
    end: (!searchParams.get('end')) ? new Date(new Date().setDate(new Date().getDate() + 7)).toLocaleDateString('en-US') : searchParams.get('end') ?? new Date(new Date().setDate(new Date().getDate() + 7)).toLocaleDateString('en-US'),
  });

  // place it for function to change start date on date range picker
  const handleChangeStartDate = (date: Date | null) => {
    if (date) {
      setSelectedDate({
        ...selectedDate,
        start: date.toLocaleDateString('en-US'),
      });
      if (location?.pathname === '/routes') {
        setSearchParams({
          ...selectedDate,
          start: date.toLocaleDateString('en-US'),
        });
      }
    }
  };

  // place it for function to change start date on date range picker
  const handleChangeEndDate = (date: Date | null) => {
    if (date) {
      setSelectedDate({
        ...selectedDate,
        end: date.toLocaleDateString('en-US'),
      });
      if (location?.pathname === '/routes') {
        setSearchParams({
          ...selectedDate,
          end: date.toLocaleDateString('en-US'),
        });
      }
    }
  };

  return {
    selectedDate, handleChangeStartDate, handleChangeEndDate,
  };
};

export default useDateRangePicker;
